<template>
  <span id='engangement'>
    <img v-if='customerObj.IsACustomerInEquity == false' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-not-a-customer.svg'
    />
    <img v-if='customerObj.IsACustomerInEquity == null' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-current-customer.svg'>
    <img v-if='customerObj.IsACustomerInEquity' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-customer-in-equity.svg' />
    <img v-if='customerObj.IsInMarketEnganged' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-in-market-engaged.svg'
    />
    <img v-if='customerObj.IsInMarketEnganged == null' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-not-in-market-not-engaged.svg'
    />
    <img v-if='customerObj.IsInMarketEnganged == false' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-in-market-not-engaged.svg'
    />
    <img v-if='customerObj.IsLookingAtVehicleInInventory' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-looking-at-vehicles-in-inventory.svg'
    />
    <img v-if='customerObj.IsLookingAtVehicleInInventory == false' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-looking-at-vehicles-not-in-inventory.svg'
    />
    <img v-if='customerObj.IsVOI' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-is-vehicle-of-interest.svg' />
    <img v-if='customerObj.IsVOI == false' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-is-not-vehicle-of-interest.svg'
    />
    <img v-if='customerObj.IsVOI == null' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-vehicle-of-interest-not-set.svg'
    />
    <img v-if='!customerObj.IsTrendingUp' class="mr-2 icon" src="static/assets/img/SVGIcons/icon-intensity-is-trending-down.svg"
    />
    <img v-if='customerObj.IsTrendingUp' class='mr-2 icon' src='static/assets/img/SVGIcons/icon-intensity-is-trending-up.svg'
    />
  </span>
</template>

<script>
  export default {
    name: 'engangementIcons',
    props: [
      'customerObj'
    ],
    created() {
      let vm = this;
      console.log(vm.customerObj)
    }
  }

</script>

<style style='scss' scoped>


</style>



// WEBPACK FOOTER //
// src/components/Icons/EngangementIcons.vue